import caller from "../../helpers/caller";

export default async function postUpdateDocumentSubType(api, payload) {
  const response = await caller(api.post, "/document_sub_type/update", payload);
  return response;
}
